import React from 'react';

const Timer = ({ time, duration = 50, isTimerOn, isMobile }) => {
  const timeContent = () => {
    return (
      <>
        <svg
          className='circle-chart'
          height='100%'
          viewBox='0 0 33.83098862 33.83098862'
          width='100%'
          xmlns='http://www.w3.org/2000/svg'
        >
          <defs>
            {/* <linearGradient id='gradient'> */}
            {/*  <stop */}
            {/*    offset='0%' */}
            {/*    style={{ stopColor: 'rgba(31, 60, 114, 0.4)' }} */}
            {/*    className='start-g-color' */}
            {/*  /> */}
            {/*  <stop offset='-100%' style={{ stopColor: 'rgba(31, 60, 114, 1)' }} /> */}
            {/* </linearGradient> */}

            <linearGradient id='gradient' x1='0%' y1='100%' className='start-g-color'>
              <stop offset='0%' style={{ stopColor: 'rgba(40, 91, 189, 0.2)' }} />
              <stop offset='100%' style={{ stopColor: 'rgba(40, 91, 189, 1)' }} />
            </linearGradient>
          </defs>

          <circle
            className='circle-chart__background'
            cx='16.91549431'
            cy='16.91549431'
            fill='none'
            r='14'
            stroke='#5184FF'
            strokeOpacity='0.16'
            strokeWidth='2.5'
          />
          <circle
            className='round-loader circle-chart__circle'
            cx='16.91549431'
            cy='16.91549431'
            fill='none'
            r='14'
            stroke='url(#gradient) #285BBD'
            strokeWidth='2.5'
            strokeDasharray='100'
            style={{ animationDuration: `${duration}s`, animationTimingFunction: 'linear' }}
            strokeDashoffset={`${-(100 - Math.floor((time / duration) * 100))}`}
          />
        </svg>
        <span className='web-wrap-svg-txt'>{time || 0}</span>
      </>
    );
  };

  if (!isTimerOn) {
    return null;
  }

  if (isMobile) {
    return time || time === 0 ? <div className='mob-wrap-svg'>{timeContent()}</div> : <></>;
  }

  return time || time === 0 ? <div className='web-wrap-svg'>{timeContent()}</div> : <></>;
};

export default Timer;
